module.exports = __webpack_public_path__ + "img/arrow-right.c160b78d.svg";